import { Avatar, Grid2, IconButton, TableCell, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import BoxEditIco from "../../../../assets/icons/BoxEditIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import SnackBar from "../../../../component/SnackBar";
import CommonAccordion from "../../../../modules/common-components/CommonAccordion";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../../modules/common-components/StyledComponents";
import { AddToJobPoolList } from "../../../../redux/action/Candidate";
import {
  RoleCall,
  TeamGetCall,
  UserIgnite,
  UserManagementPost,
  UserManagementPut,
  UserManagementRoleDelete,
  UserManagementRoleManage,
  UserMatch,
  UserResume,
} from "../../../../redux/action/UserManagement";
import AddUser from "./add-user";
import ManagePermission from "./components/ManagePermission";
import RemoveMember from "./components/RemoveMember";
import Team from "./components/Team";

export default function UserManagement() {
  const [teamList, setTeamList] = useState({
    data: [],
    loading: true,
  });
  const [checkSelected, setCheckSelected] = useState({
    count: 0,
    selected: [],
    managePermission: [],
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [dialog, setDialog] = useState({
    removeOpen: false,
    manageOpen: false,
    disabled: false,
    removeLoading: false,
    manageLoading: false,
  });
  const [headerData, setHeaderData] = useState([
    { name: "User", width: "22%" },
    { name: "Position", width: "22%" },
    { name: "Permissions", width: "22%" },
    { name: "Email Address", width: "22%" },
    { width: "10%" },
  ]);
  //Edit Mode
  const [userManagement, setUserManagement] = useState({
    edit_mode: false,
    view_mode: false,
    add_mode: false,
  });
  const [isLoading, setIsLoading] = useState(true);
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const [expandedPanel, setExpandedPanel] = useState([
    "General",
    "Information",
    "Demo Config",
  ]);
  const handleOpenDialog = (condition) => {
    setDialog((prev) => ({
      ...prev,
      removeOpen: condition === "remove" ? true : false,
      manageOpen: condition === "manage" ? true : false,
    }));
  };
  const handleCloseRemoveMember = () => {
    setDialog({
      removeOpen: false,
      manageOpen: false,
      disabled: false,
      removeLoading: false,
      manageLoading: false,
    });
  };

  const handleAddMemberClick = () => {
    setUserManagement((prev) => ({
      ...prev,
      add_mode: true,
    }));
    handleFetchModeCall();
  };

  const handleFetchCall = async () => {
    setTeamList((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await TeamGetCall();
      const dataRole = await RoleCall();
      setTeamList((prev) => ({
        ...prev,
        data: data?.data,
        loading: false,
        role: dataRole?.roles,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setTeamList((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };
  useEffect(() => {
    handleFetchCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleIconClick = (condition, row) => {
    if (condition === "view") {
      setUserManagement((prev) => ({
        ...prev,
        add_mode: true,
        view_mode: true,
        id: row.id,
      }));
      handleFetchModeCall(row.id);
    } else if (condition === "edit") {
      setUserManagement((prev) => ({
        ...prev,
        add_mode: true,
        edit_mode: true,
        id: row.id,
      }));
      handleFetchModeCall(row.id);
    }
  };

  const handleTeamTableBodyData = (row) => (
    <>
      <TableCell>
        <CommonGrid2 container alignItems="center" spacing={2}>
          <Avatar
            alt={row.full_name}
            src={row.full_name}
            sx={{ fontWeight: "700" }}
          />
          {row.full_name}
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.title || "-"}</TableCell>
      <TableCell>
        <StatusChange>
          <DotColor
            color={
              row.role_name === "Base"
                ? "#667085"
                : row.role_name === "Manager"
                ? "orange"
                : row.role_name === "Admin"
                ? "green"
                : "#667085"
            }
          />
          {row.role_name}
        </StatusChange>
      </TableCell>
      <TableCell>{row.email}</TableCell>
      <TableCell>
        <CommonGrid2
          display={"flex"}
          gap={"1rem"}
          justifyContent={"space-around"}
        >
          <Tooltip arrow title="View" placement="top">
            <IconButton
              onClick={() => handleIconClick("view", row)}
              style={{ cursor: "pointer" }}
            >
              <EyeIco />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title="Edit" placement="top">
            <IconButton
              onClick={() => handleIconClick("edit", row)}
              style={{ cursor: "pointer" }}
            >
              <BoxEditIco />
            </IconButton>
          </Tooltip>
        </CommonGrid2>
      </TableCell>
    </>
  );

  const handleSingleSelect = (row) => {
    setCheckSelected((prev) => {
      const isSelected = prev.selected.some((item) => item.id === row.id);
      const updatedSelected = isSelected
        ? prev.selected.filter((item) => item.id !== row.id)
        : [...prev.selected, { ...row, id: row.id }];

      const updatedCount = updatedSelected.length;

      return {
        selected: updatedSelected,
        count: updatedCount,
        managePermission: updatedSelected,
      };
    });
  };

  const handleSelectAll = () => {
    const allIds = teamList.data.map((row) => ({
      ...row,
      id: row.id,
    }));

    if (
      teamList.data.every((row) =>
        checkSelected.selected.some((item) => item.id === row.id)
      )
    ) {
      const deselectedIds = checkSelected.selected.filter(
        (item) => !allIds.some((row) => row.id === item.id)
      );
      setCheckSelected({
        selected: deselectedIds,
        count: deselectedIds.length,
        managePermission: deselectedIds,
      });
    } else {
      const updatedSelected = [...checkSelected.selected, ...allIds];
      const uniqueSelected = Array.from(
        new Set(updatedSelected.map((item) => item.id))
      ).map((id) => updatedSelected.find((item) => item.id === id));

      setCheckSelected({
        selected: uniqueSelected,
        count: uniqueSelected.length,
        managePermission: uniqueSelected,
      });
    }
  };

  const handleChangeStatus = (e, index) => {
    setCheckSelected((prev) => ({
      ...prev,
      managePermission: prev.managePermission.map((item, i) =>
        i === index
          ? {
              ...item,
              role_id: e.target.value,
              role_name: teamList.role.find(
                (role) => role.id === e.target.value
              )?.name,
            }
          : item
      ),
    }));
  };

  const handleRemoveMember = async () => {
    try {
      setDialog((prev) => ({
        ...prev,
        disabled: true,
        removeLoading: true,
      }));
      let payload = {
        user_ids: checkSelected.selected.map((item) => item.id),
      };
      const getData = await UserManagementRoleDelete(payload);
      await handleFetchCall();
      handleCloseRemoveMember();
      setCheckSelected({
        count: 0,
        selected: [],
        managePermission: [],
      });
      setSnackbarState({
        open: true,
        severity: "success",
        message: getData?.message,
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setDialog((prev) => ({
        ...prev,
        disabled: false,
        removeLoading: false,
      }));
    }
  };

  const handleManageMember = async () => {
    if (
      JSON.stringify(checkSelected.managePermission) ===
      JSON.stringify(checkSelected.selected)
    ) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Change any one of the values and update it",
      });
    } else {
      try {
        setDialog((prev) => ({
          ...prev,
          disabled: true,
          manageLoading: true,
        }));
        let payload = {
          user_roles: checkSelected.managePermission.map((item) => ({
            user_id: item.id,
            role_id: item.role_id,
          })),
        };
        let data = await UserManagementRoleManage(payload);
        await handleFetchCall();
        handleCloseRemoveMember();
        setCheckSelected({
          count: 0,
          selected: [],
          managePermission: [],
        });
        setSnackbarState({
          open: true,
          severity: "success",
          message: data?.message,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setDialog((prev) => ({
          ...prev,
          disabled: false,
          manageLoading: false,
        }));
      }
    }
  };

  //Edit Mode
  const handleSwitch = () => {
    setUserManagement({
      edit_mode: false,
      view_mode: false,
      add_mode: false,
      id: "",
    });
    handleFetchCall();
  };

  const [buttonLoading, setButtonLoading] = useState({
    disabled: false,
    loading: false,
    cancelLoading: false,
  });
  const [userData, setUserData] = useState({
    username: "",
    password: "",
    full_name: "",
    avatar: "",
    email: "",
    company_name: "",
    title: "",
    time_zone: "",
    time_zone_data: [
      { name: "Eastern Standard Time(EST)" },
      { name: "Central Standard Time(CST)" },
      { name: "Mountain Standard Time(MST)" },
      { name: "Pacific Standard Time(PST)" },
      { name: "Indian Standard Time(IST)" },
      { name: "Gulf Standard Time(GST)" },
      { name: "Greenwich Standard Time(GST)" },
    ],
    company_address: "",
    role_id: "",
    role: [],
    job_id: "",
    job_data: [],
    resume_data: [],
    resume_id: "",
    match_data: [],
    match_id: "",
    ignite_data: [],
    ignite_id: "",
  });

  const primaryViewData = [
    {
      title: "Full Name",
      component: "input",
      titleName: "full_name",
      placeholder: "Enter Full Name",
      placeholderFontSize: "15px",
      disabled: userManagement.view_mode,
    },
    {
      title: "Avatar",
      component: "fileUpload",
      titleName: "avatar",
      placeholder: "Select Avatar",
      placeholderFontSize: "15px",
      disabled: true,
    },
    {
      title: "Company Name",
      component: "input",
      titleName: "company_name",
      placeholder: "Enter Company Name",
      placeholderFontSize: "15px",
      disabled: userManagement.view_mode,
    },
    {
      title: "Title",
      component: "input",
      titleName: "title",
      placeholder: "Enter Title",
      placeholderFontSize: "15px",
      disabled: userManagement.view_mode,
    },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter Email Address",
      placeholderFontSize: "15px",
      disabled: userManagement.view_mode,
    },
    {
      title: "Timezone",
      component: "dropDown",
      titleName: "time_zone",
      dropDownData: "time_zone_data",
      placeholder: "Select Zone",
      disabled: userManagement.view_mode,
      valueChange: false,
      CustomMenuItem: true,
    },
    {
      title: "Company Address",
      component: "input",
      titleName: "company_address",
      placeholder: "Enter Company Address",
      placeholderFontSize: "15px",
      disabled: userManagement.view_mode,
    },
    {
      title: "Role",
      component: "dropDown",
      titleName: "role_id",
      dropDownData: "role",
      placeholder: "Select Role",
      valueChange: true,
      disabled: userManagement.view_mode,
    },
  ];

  const DemoConfigData = [
    {
      title: "Job",
      component: "dropDown",
      titleName: "job_id",
      dropDownData: "job_data",
      placeholder: "Select Job",
      valueChange: true,
      disabled: userManagement.view_mode,
    },
    {
      title: "Match",
      component: "dropDown",
      titleName: "resume_id",
      dropDownData: "resume_data",
      placeholder: "Select Match",
      valueChange: true,
      disabled: userManagement.view_mode,
    },
    {
      title: "Resume",
      component: "dropDown",
      titleName: "match_id",
      dropDownData: "match_data",
      placeholder: "Select Resume",
      valueChange: true,
      disabled: userManagement.view_mode,
    },
    {
      title: "Ignite",
      component: "dropDown",
      titleName: "ignite_id",
      dropDownData: "ignite_data",
      placeholder: "Select Ignite",
      valueChange: true,
      disabled: userManagement.view_mode,
    },
  ];

  const validationSchema = Yup.object({
    username: Yup.string().required("User Name is required"),
    full_name: Yup.string().required("Full Name is required"),
    company_name: Yup.string().required("Company Name is required"),
    title: Yup.string().required("Title is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
    time_zone: Yup.string().required("TimeZone is required"),
    company_address: Yup.string().required("Company Address is required"),
    role_id: Yup.string().required("Role is required"),
  });

  const handleFetchModeCall = async (id) => {
    try {
      setIsLoading(true);
      let teamData;
      let JobId;
      let resumeId;
      let matchId;
      let igniteId;
      if (id) {
        teamData = await TeamGetCall(true, id);
      }
      let params = {
        limit: 10,
        offset: 0,
        pagination: "no",
      };
      const data = await RoleCall();
      if (
        storageData.organization === "Demo" &&
        storageData?.role === "Admin"
      ) {
        JobId = await AddToJobPoolList();
        resumeId = await UserResume(params);
        matchId = await UserMatch();
        igniteId = await UserIgnite();
      }

      setUserData((prev) => ({
        ...prev,
        role: data?.roles,
        job_data:
          (JobId &&
            JobId?.data?.map((item, index) => ({
              ...item,
              name: item.title,
            }))) ||
          [],
        resume_data: (resumeId && resumeId.data) || [],
        match_data:
          matchId?.data?.map((item, index) => ({
            ...item,
            name: item.candidate_name,
          })) || [],
        ignite_data:
          igniteId?.data?.map((item, index) => ({
            ...item,
            name: item.client_name,
          })) || [],
        ...(id
          ? {
              username: teamData?.data?.username,
              password: teamData?.data?.password,
              full_name: teamData?.data?.full_name,

              email: teamData?.data?.email,
              company_name: teamData?.data?.company_name,
              title: teamData?.data?.title,
              time_zone: teamData?.data?.time_zone,

              company_address: teamData?.data?.company_address,
              role_id: data?.roles?.find(
                (role) => role.name === teamData?.data?.role_name
              )?.id,
              job_id: teamData?.data?.demo_config?.job_id || "",
              resume_id: teamData?.data?.demo_config?.resume_id || "",
              match_id: teamData?.data?.demo_config?.match_id || "",
              ignite_id: teamData?.data?.demo_config?.ignite_id || "",
            }
          : {}),
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleSubmit = async (values) => {
    setButtonLoading((prev) => ({
      ...prev,
      disabled: true,
      addLoading: true,
    }));
    let payload = {
      username: values.username,
      password: values.password,
      full_name: values.full_name,
      avatar: "",
      email: values.email,
      company_name: values.company_name,
      title: values.title,
      time_zone: values.time_zone,
      company_address: values.company_address,
      role_id: values.role_id,

      ...(storageData.organization === "Demo" && storageData?.role === "Admin"
        ? {
            demo_config: {
              job_id: values.job_id,
              resume_id: values.resume_id,
              match_id: values.match_id,
              ignite_id: values.ignite_id,
            },
          }
        : {}),
    };
    try {
      const data = userManagement.id
        ? await UserManagementPut(userManagement.id, payload)
        : await UserManagementPost(payload);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      setTimeout(() => {
        handleSwitch();
        setButtonLoading((prev) => ({
          ...prev,
          disabled: false,
          addLoading: false,
        }));
      }, 800);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.error || error.message,
      });
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        addLoading: false,
      }));
    }
  };

  const handleChangeAccor = (panel) => (_, isExpanded) => {
    setExpandedPanel((prev) =>
      isExpanded ? [...prev, panel] : prev.filter((p) => p !== panel)
    );
  };

  const handleScrollToErrorCheck = (error) => {
    setExpandedPanel((prev) => {
      const newPanels = new Set(prev);
      if (error.username || error.password) {
        newPanels.add("General");
      } else if (Object.keys(error).length !== 0) {
        newPanels.add("Information");
      }
      return Array.from(newPanels);
    });
    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 0);
  };

  const handleCancel = () => {
    setButtonLoading((prev) => ({
      ...prev,
      cancelLoading: true,
      disabled: true,
    }));
    setTimeout(() => {
      handleSwitch();
      setButtonLoading((prev) => ({
        ...prev,
        cancelLoading: false,
        disabled: false,
      }));
    }, 1000);
  };

  return (
    <Grid2 container margin={"1.5rem"}>
      {!userManagement.add_mode ? (
        <CommonGrid2 size={12}>
          <CommonAccordion
            title={"Team"}
            accordionButton
            buttonTitle={"Add Member"}
            children={
              <Team
                teamList={teamList}
                handleTeamTableBodyData={handleTeamTableBodyData}
                headerData={headerData}
                checkSelected={checkSelected}
                handleSingleSelect={handleSingleSelect}
                handleSelectAll={handleSelectAll}
                handleOpenDialog={handleOpenDialog}
              />
            }
            onButtonClick={handleAddMemberClick}
            defaultOpen
          />
        </CommonGrid2>
      ) : (
        <AddUser
          userManagement={userManagement}
          isLoading={isLoading}
          storageData={storageData}
          expandedPanel={expandedPanel}
          buttonLoading={buttonLoading}
          userData={userData}
          primaryViewData={primaryViewData}
          DemoConfigData={DemoConfigData}
          validationSchema={validationSchema}
          handleSubmit={handleSubmit}
          handleChangeAccor={handleChangeAccor}
          handleScrollToErrorCheck={handleScrollToErrorCheck}
          handleCancel={handleCancel}
        />
      )}
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <RemoveMember
        open={dialog.removeOpen}
        onClose={handleCloseRemoveMember}
        onApply={handleRemoveMember}
        selectedUser={checkSelected.selected}
        dialog={dialog}
      />
      <ManagePermission
        open={dialog.manageOpen}
        onClose={handleCloseRemoveMember}
        onApply={handleManageMember}
        options={teamList.role}
        selectedUser={checkSelected.managePermission}
        handleChangeStatus={handleChangeStatus}
        dialog={dialog}
      />
    </Grid2>
  );
}
